import * as React from 'react';
import { TabToggle } from '../../../../web/components-v2/TabToggle';
import { styleSheet } from '../styles';
import { displayLabels, isSortOption, SortOptions } from './ListHeader';

interface IProps {
	onSelect: (option: SortOptions) => void;
	selected: SortOptions;
}

const ITEMS = Object.values(SortOptions).map(value => ({ label: displayLabels[value], value }));

export const ListColumnNav: React.FC<IProps> = ({ onSelect, selected }) => (
	<TabToggle
		aria-label='Column to show'
		items={ITEMS}
		size='small'
		styles={[styleSheet.columnNav]}
		value={selected}
		onValueChange={next => {
			if (isSortOption(next)) {
				onSelect(next);
			}
		}}
	/>
);
